export default "__VITE_ASSET__7aj_wtFz__"